<template>
  <page>
    <template slot="content">
      <help-content :title="'グループ内で表示されるメンバーの情報'">
        <template slot="content">
          <div class="text">
            グループに参加する時に、メンバーが入力した<b>表示名、所属部門、連絡用携帯番号、連絡用メールアドレス</b>および日々の歩数データがグループ内でシェアされます。<br>
            ※<b>ユーザー登録時にアカウントとして入力された携帯番号またはEメールが他人に見られることはありません。</b>
          </div>
          <div class="text">            
            各項目について、管理者が「グループ管理」画面にて変更することが可能です。<b>連絡用携帯番号と連絡用メールアドレスの表示／非表示の切替えもできます。</b>
          </div>
          <div class="text">
            表示名、連絡用携帯番号、連絡用メールアドレス：メンバー自身が「MYグループ」画面で内容を変更できます。
          </div>
          <div class="text">
            所属部門：メンバー自身が変更できません。変更の場合は管理者に依頼してください。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/HelpAdmin2.vue